import { useState, useEffect } from 'react';
import { recordVisit } from '../services/portfolioApi';

export function useVisitorCount() {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    recordVisit()
      .then(setCount)
      .catch(() => setCount(null));
  }, []);

  return count;
}
